import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { LabelEditorField } from '@nextiva/engagement-ui';

import sanitizeLabelInput from '../../../../domains/blockEditor/utils/sanitizeLabelInput';

const RatingScaleLabelEditorItem = ({
  index,
  labelName,
  labelKey,
  containerClassName,
  labelClassName,
  styleLabel,
}) => {
  return (
    <div className={containerClassName}>
      <Field
        key={labelKey}
        name={labelName}
        component={LabelEditorField}
        parse={sanitizeLabelInput}
        props={{
          index,
          spellCheck: true,
          placeholder: 'label',
          className: labelClassName,
          style: styleLabel,
        }}
      />
    </div>
  );
};

RatingScaleLabelEditorItem.propTypes = {
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  labelName: PropTypes.string.isRequired,
  labelKey: PropTypes.string,
  containerClassName: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,
  styleLabel: PropTypes.object,
};

export default RatingScaleLabelEditorItem;
